<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" [title]="title"> </sm-page-header>
  <div class="flex flex-row gap-5">
    <!-- Form -->
    <div class="content w-3/4">
      <sm-form-builder [formObject]="formObject"></sm-form-builder>
    </div>
    <!-- Meta Blocks -->
    <div class="flex flex-col gap-2 w-1/4">
      <div class="content h-fit">
        <sm-block-builder [blocks]="controlBlocks"></sm-block-builder>
      </div>
    </div>
  </div>
</div>
